export default [
  {
    id: 1,
    title: "International Food Company",
    money: "$50",
    currency: "billion",
    text: "上线TPM，提高销售上报活动的灵活性",
    img: require("../../assets/img/industrySolutions/content-1.png"),
    tag: "#TPM",
    navTheme: "white"
  },
  {
    id: 2,
    title: "International Food Company",
    money: "$36",
    currency: "billion",
    text: "上线TPM，实现费用管控与费用审批标准化，费用全程可追溯",
    img: require("../../assets/img/industrySolutions/content-2.png"),
    tag: "#TPM",
    navTheme: "white"
  },
  // {
  //   id: 3,
  //   title: "食品品牌",
  //   money: "260亿",
  //   currency: "美元",
  //   text: "上线TPM，助力多方位预算高效管理与费用核销效率",
  //   img: require("../../assets/img/industrySolutions/content-3.png"),
  //   tag: ["TPM", "食品"],
  //   navTheme: "white"
  // },
  // {
  //   id: 4,
  //   title: "医疗品牌",
  //   money: " 850亿",
  //   currency: "美元",
  //   text: "上线TPM，实现费用灵活管控与上报活动的便捷性，费用全程...",
  //   img: require("../../assets/img/industrySolutions/content-4.png"),
  //   tag: ["TPM", "其他"],
  //   navTheme: "black"
  // },
  {
    id: 5,
    title: "International Beverage Company",
    money: "$900",
    currency: "million",
    text: "上线TPM+SFA，实现费用流转强闭环管理",
    img: require("../../assets/img/industrySolutions/content-5.png"),
    tag: "#TPM + SFA",
    navTheme: "black"
  },
  // {
  //   id: 6,
  //   title: "国际日化品牌",
  //   money: "840亿",
  //   currency: "美元",
  //   text: "上线TPO，增强经营意识，实现销售增量和ROI平衡",
  //   img: require("../../assets/img/industrySolutions/content-6.png"),
  //   tag: ["TPM+", "日化"],
  //   navTheme: "white"
  // },
  // {
  //   id: 7,
  //   title: "软饮品牌",
  //   money: "8亿",
  //   currency: "美元",
  //   text: "上线TPM+DP，实现经销商门户与营销费用管理基础建设",
  //   img: require("../../assets/img/industrySolutions/content-7.png"),
  //   tag: ["TPM+", "软饮"],
  //   navTheme: "black"
  // },
  // {
  //   id: 8,
  //   title: "奶粉品牌",
  //   money: "77亿",
  //   currency: "人民币",
  //   text: "上线渠道数字化—终端管理，实现全链路一体化运营",
  //   img: require("../../assets/img/industrySolutions/content-8.png"),
  //   tag: ["SFA", "乳业"],
  //   navTheme: "black"
  // },
  // {
  //   id: 9,
  //   title: "高端茶品牌",
  //   money: "20亿",
  //   currency: "人民币",
  //   text: "构建数据中心，打通线上线下数据，提供统一、全面、标准的...",
  //   img: require("../../assets/img/industrySolutions/content-9.png"),
  //   tag: ["全域数据洞察", "其他"],
  //   navTheme: "white"
  // },
  // {
  //   id: 10,
  //   title: "乳品品牌",
  //   money: "1260亿",
  //   currency: "人民币",
  //   text: "整合电商多平台数据，以成熟的分析模型搭建电商业务洞察报...",
  //   img: require("../../assets/img/industrySolutions/content-10.png"),
  //   tag: ["全域数据洞察", "乳业"],
  //   navTheme: "black"
  // },
  {
    id: 12,
    title: "International Personal Care Company",
    money: "$84",
    currency: "billion",
    text: "从线下到全域全渠道各类数据服务，为数据中台的建设夯实基础",
    img: require("../../assets/img/industrySolutions/content-12.png"),
    tag: "#Business Intelligence",
    navTheme: "black"
  },
  // {
  //   id: 11,
  //   title: "国际啤酒品牌",
  //   money: "600亿",
  //   currency: "人民币",
  //   text: "实现所有销售分析指标标准化，建设统一数据分析平台，全面...",
  //   img: require("../../assets/img/industrySolutions/content-11.png"),
  //   tag: ["全域数据洞察", "酒水"],
  //   navTheme: "white"
  // },

  // {
  //   id: 13,
  //   title: "白酒品牌",
  //   money: "50亿",
  //   currency: "人民币",
  //   text: "搭建BC联动可视化看板及自助分析工具，实现数字化随时随地...",
  //   img: require("../../assets/img/industrySolutions/content-13.png"),
  //   tag: ["全域数据洞察", "酒水"],
  //   navTheme: "white"
  // },
  // {
  //   id: 14,
  //   title: "口腔护理品牌",
  //   money: "195亿",
  //   currency: "美元",
  //   text: "实施电商评论分析项目，实现消费者意见洞察",
  //   img: require("../../assets/img/industrySolutions/content-14.png"),
  //   tag: ["全域数据洞察", "日化"],
  //   navTheme: "black"
  // },
  // {
  //   id: 15,
  //   title: "婴幼儿食品与护理品牌",
  //   money: "140亿",
  //   currency: "人民币",
  //   text: "上线消费者运营分析平台，实现更精准会员运营与推广营...",
  //   img: require("../../assets/img/industrySolutions/content-15.png"),
  //   tag: ["全域数据洞察", "食品"],
  //   navTheme: "black"
  // },
  // {
  //   id: 16,
  //   title: "国际日化品牌",
  //   money: "840亿",
  //   currency: "美元",
  //   text: "实施GP项目，统一管理6大类型主数据，实现主数据可持续运营",
  //   img: require("../../assets/img/industrySolutions/content-16.png"),
  //   tag: ["主数据", "日化"],
  //   navTheme: "white"
  // },
  {
    id: 17,
    title: "International Beer Company",
    money: "$10.7",
    currency: "billion",
    text: "对7大类型主数据梳理整合，实现平台化管理，提供高质量数...",
    img: require("../../assets/img/industrySolutions/content-17.png"),
    tag: "#MDM",
    navTheme: "white"
  },
  // {
  //   id: 18,
  //   title: "食品品牌",
  //   money: "260亿",
  //   currency: "美元",
  //   text: "梳理5大商务类型主数据，统一数据管理标准及口径，降本增效",
  //   img: require("../../assets/img/industrySolutions/content-18.png"),
  //   tag: ["主数据", "食品"],
  //   navTheme: "black"
  // },
  {
    id: 19,
    title: "Healthcare Company",
    money: "$1.35",
    currency: "billion",
    text: "构建聚焦新品研发及新品测试的工作协同平台，实现产品研发...",
    img: require("../../assets/img/industrySolutions/content-19.png"),
    tag:"#Product Innovation Platform",
    navTheme: "black"
  },
  // {
  //   id: 20,
  //   title: "食品品牌",
  //   money: "500亿",
  //   currency: "美元",
  //   text: "旨在打造更全面、简洁和高效的线上流程。实现新品上市的全...",
  //   img: require("../../assets/img/industrySolutions/content-20.png"),
  //   tag: ["新品协同", "食品"],
  //   navTheme: "white"
  // },
  // {
  //   id: 21,
  //   title: "酒水品牌",
  //   money: "50亿",
  //   currency: "人民币",
  //   text: "实现品牌数字化落地和业务全流程管理",
  //   img: require("../../assets/img/industrySolutions/content-21.png"),
  //   tag: ["B2B", "酒水"],
  //   navTheme: "white"
  // },
  // {
  //   id: 22,
  //   title: "口腔护理品牌",
  //   money: "195亿",
  //   currency: "美元",
  //   text: "搭建经销商管理平台，为业务扩展做铺垫",
  //   img: require("../../assets/img/industrySolutions/content-22.png"),
  //   tag: ["B2B", "日化"],
  //   navTheme: "black"
  // },
  // {
  //   id: 23,
  //   title: "软饮品牌",
  //   money: "8亿",
  //   currency: "美元",
  //   text: "实现多渠道订单业务标准化管理",
  //   img: require("../../assets/img/industrySolutions/content-23.png"),
  //   tag: ["B2B", "软饮"],
  //   navTheme: "black"
  // },
  // {
  //   id: 24,
  //   title: "眼镜品牌",
  //   money: "6亿",
  //   currency: "人民币",
  //   text: "实现品牌与渠道的高效协同及精准赋能",
  //   img: require("../../assets/img/industrySolutions/content-24.png"),
  //   tag: ["B2B", "其他"],
  //   navTheme: "white"
  // },
  // {
  //   id: 25,
  //   title: "石化股份有限公司",
  //   type: "target",
  //   target: "洛阳",
  //   text: "打造科技+精细化管理模式，树立企业绿色、创新、共赢的良...",
  //   img: require("../../assets/img/industrySolutions/content-25.png"),
  //   tag: ["智慧系列", "地产与石化"],
  //   navTheme: "white"
  // },
  // {
  //   id: 26,
  //   title: "化工有限公司",
  //   type: "target",
  //   target: "武汉",
  //   text: "通过改造与优化物流管理系统功能，满足实际新增业务需求...",
  //   img: require("../../assets/img/industrySolutions/content-26.png"),
  //   tag: ["智慧系列", "地产与石化"],
  //   navTheme: "white"
  // },
  // {
  //   id: 27,
  //   title: "石化股份有限公司",
  //   type: "target",
  //   target: "泉州",
  //   text: "实现仓库管理可视化",
  //   img: require("../../assets/img/industrySolutions/content-27.png"),
  //   tag: ["智慧系列", "地产与石化"],
  //   navTheme: "white"
  // },
  // {
  //   id: 28,
  //   title: "知名物业公司",
  //   type: "target",
  //   target: "珠海",
  //   text: "打通停车场设备及系统间壁垒，降本增效",
  //   img: require("../../assets/img/industrySolutions/content-28.png"),
  //   tag: ["智慧系列", "其他"],
  //   navTheme: "white"
  // },
  // {
  //   id: 29,
  //   title: "大型家居企业园区",
  //   type: "target",
  //   target: "广州",
  //   text: "该系统覆盖全方位物业服务，打造一体化物业管理平台",
  //   img: require("../../assets/img/industrySolutions/content-29.png"),
  //   tag: ["智慧系列", "其他"],
  //   navTheme: "white"
  // },
  // {
  //   id: 30,
  //   title: "大型地产集团商业中心",
  //   type: "target",
  //   target: "武汉",
  //   text: "打造新时代智慧商场新模式，为顾客赋能增值",
  //   img: require("../../assets/img/industrySolutions/content-30.png"),
  //   tag: ["智慧系列", "其他"],
  //   navTheme: "white"
  //},
    {
    id: 31,
    title: "Cosmetics brand",
    money: "￥4 ",
    currency: "billion",
    text: "实现多渠道订单业务标准化管理",
    img: require("../../assets/img/industrySolutions/content-31.png"),
    tag:"#Product Innovation Platform",
    navTheme: "white"
  },
];



// WEBPACK FOOTER //
// ./src/view/solutions/cases.js